import { useStakeDialog } from './logic/useStakeDialog'
import { StakeView } from './views/StakeView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface StakeContainerProps {
  closeDialog: () => void
}

function StakeDialogContentContainer({ closeDialog }: StakeContainerProps) {
  const {
    selectableAssets,
    assetsFields,
    form,
    stakedToken,
    pageStatus,
    txOverview,
    actionsViewState,
    sacrificesYield,
  } = useStakeDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="stake"
        tokenWithValue={stakedToken}
        proceedText="Back to Farm"
        onProceed={closeDialog}
      />
    )
  }

  return (
    <StakeView
      form={form}
      selectableAssets={selectableAssets}
      assetsFields={assetsFields}
      sacrificesYield={sacrificesYield}
      txOverview={txOverview}
      actionsViewState={actionsViewState}
    />
  )
}

const StakeDialogContentContainerWithSuspense = withSuspense(StakeDialogContentContainer, DialogContentSkeleton)
export { StakeDialogContentContainerWithSuspense as StakeDialogContentContainer }
